// Must be @apollo/client's Observable (zen-observable-ts), not apollo-link's separate copy -
// the error link calls .subscribe() on what this returns, and mixing the two Observable
// implementations throws "subscribe is not a function". Import from the /core entry (as the rest
// of this module does) so we don't drag Apollo's React layer (rehackt -> react) into this Vue app.
import { Observable } from '@apollo/client/core'

export default (promise: Promise<any>) => {
  return new Observable((subscriber: any) => {
    promise.then(
      (value) => {
        if (subscriber.closed) return;
        subscriber.next(value)
        subscriber.complete()
      },
      err => subscriber.error(err)
    )
  })
}
